import { TierPrice } from '../TieredPricing';

export function itemPriceFromTier(tierPrices: TierPrice[], qtySelected: number, vat: boolean): number {
    const isSingle = qtySelected === 1;
    if (isSingle) {
        const singleMatch = tierPrices.find((tp) => tp.qty === 1);
        if (singleMatch) {
            return vat ? singleMatch.price_incl : singleMatch.price;
        } else {
            throw new Error('could not find the matching tier price');
        }
    }
    const match = tierPrices.find((tp, index) => {
        const next = tierPrices[index + 1];
        const nextQty = (next && next.qty) ?? Infinity;
        const isActive = qtySelected >= tp.qty && qtySelected < nextQty;
        return isActive;
    });

    if (match) {
        return vat ? match.price_incl : match.price;
    }

    return 0;
}
